export const alertsModalPageTestIDs = {
  alertsModalPage: 'alerts_modal_page',
  alertsModalPageFocus: 'alerts_modal_page_focus',
};
